// components/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../context/QuizContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { dispatch } = useQuiz();
  const [studentInfo, setStudentInfo] = useState({
    name: '',
    studentId: '',
    email: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (studentInfo.name && studentInfo.studentId && studentInfo.email) {
      dispatch({ type: 'SET_STUDENT_INFO', payload: studentInfo });
      navigate('/instructions');
    } else {
      alert('Please fill all fields');
    }
  };

  const handleChange = (e) => {
    setStudentInfo({
      ...studentInfo,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Quiz Login</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              name="name"
              value={studentInfo.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Student ID:</label>
            <input
              type="text"
              name="studentId"
              value={studentInfo.studentId}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={studentInfo.email}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="btn-primary">
            Start Quiz
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;